"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const lucide_vue_next_1 = require("lucide-vue-next");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const zip_1 = __importDefault(require("@common/utils/zip"));
const trans_1 = require("@common/tsutils/trans");
let BulkDownloader = class BulkDownloader extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.state = 'normal';
        this.zipName = 'Reports.zip';
        this.downloadProgress = 0;
        this.totalDownloaded = 0;
        this.downloadSetSize = 0;
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    async downloadReports() {
        try {
            const zipname = `${this.zipTitle}.zip`;
            const zip = new zip_1.default();
            //const fakeSamples = [{code: 'CI348A'}, {code: 'CI348B'}, {code: 'CI348C'}]
            this.downloadSetSize = this.samples.length;
            this.downloadProgress = 0;
            this.totalDownloaded = 0;
            this.state = 'downloading';
            this.$emit('downloading');
            for (const [i, sample] of this.samples.entries()) {
                //this.downloadInfo.donutCurrent = i + 1;
                this.downloadProgress = Math.round((100 / this.downloadSetSize) * (i + 1));
                this.totalDownloaded = (i + 1);
                const url = '/report/pdf/' + sample.code;
                await zip.addURL(url);
            }
            await zip.download(zipname);
            this.downloadProgress = 100;
            this.state = 'normal';
            this.$emit('downloaded');
        }
        catch (e) {
            console.log(e);
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'bulk' })
], BulkDownloader.prototype, "zipTitle", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'primary' })
], BulkDownloader.prototype, "accent", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'normal' })
], BulkDownloader.prototype, "trigger", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'units' })
], BulkDownloader.prototype, "progressFormat", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: [] })
], BulkDownloader.prototype, "samples", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: (0, trans_1.trans)('trialsSummaryPublic.download_all') })
], BulkDownloader.prototype, "title", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], BulkDownloader.prototype, "theme", void 0);
BulkDownloader = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Button: bmk_ui_framework_1.Button,
            Loader: bmk_ui_framework_1.Loader,
            ProgressBarAlt: bmk_ui_framework_1.ProgressBarAlt,
            ArrowDown: lucide_vue_next_1.ArrowDown,
        },
    })
], BulkDownloader);
exports.default = BulkDownloader;
